import React from 'react';
import '../styles/About.css';

const About = () => {
  return (
    <section className="about" id="about">
      <div className="about-container">
        <div className="about-header">
          <h2 className="section-title">關於我們</h2>
        </div>
        <div className="about-content">
          <div className="about-image">
            <img 
              src={require('../images/logo.png')} 
              alt="聯漢室內設計工作室標誌 - 專業室內設計公司商標" 
              width="200"
              height="200"
            />
          </div>
          <div className="about-text">
            <h3>關於聯漢</h3>
            <p>
              聯漢室內設計成立於民國78年6月6日，
              迄今已有三十年載。
              團隊擁有專業證照，並將多年累積的美學與經驗，
              把各種不同的設計風格，做出最佳的呈現，
              打造出居住者/使用者能感到幸福的空間。
            </p>
            <p>
              歡迎免費諮詢丈量，估價諮詢。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About; 